import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountTransferScheduleResponse,
  AccountTransferFund: (params: vp.AccountTransferScheduleRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountTransferWithdrawSchedule: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountTransferScheduleRequest>({
    DebitorClientAccountID: '',
    RecipientClientAccountID: '',
    RecipientClientAccountIDSplit: '',
    Amount: 0,
    ClientReferenceNumber: '',
    Notes: '',
    TransactionLabel: '',
    Frequency: 'single',
    Description: '',
    Currency: '',
  });
  const [response, setResponse] = useState<vp.AccountTransferScheduleResponse>({
    Success: false,
    ErrorMessage: '',
    ScheduledTransfersID: '',
  });

  useEffect(() => {
    if (!shouldSendRequest) return () => {};

    const PostAccountTransferFund = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      // Remove RecipientClientAccountID or RecipientClientAccountIDSplit from params as both cant be passed
      const filteredParams = { ...params };
      if (params.RecipientClientAccountIDSplit !== '') {
        delete filteredParams.RecipientClientAccountID;
      } else {
        delete filteredParams.RecipientClientAccountIDSplit;
      }

      const res = await api.postAccountTransferWithdrawSchedule(filteredParams, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSendRequest) void PostAccountTransferFund();
    setSendRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.AccountTransferScheduleRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        ScheduledTransfersID: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountTransferWithdrawSchedule);
